import { Box, Grid, IconButton } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { TelephoneMinusFill, TelephonePlusFill } from 'react-bootstrap-icons';
import { VoiceStatus } from 'server-sdk/types';
import { H3 } from 'src/base';
import { Text } from 'src/base/texts/Text';
import { Dialog } from 'src/deps/mui';

interface VoiceCallingModalProps {
  currentCall: any;
  toNumber: string;
  status: VoiceStatus;
  hangUp: () => void;
  acceptIncomingCall: () => void;
  rejectIncomingCall: () => void;
}

export const VoiceCallingModal: React.FC<VoiceCallingModalProps> = ({
  currentCall,
  toNumber,
  status,
  hangUp,
  acceptIncomingCall,
  rejectIncomingCall,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [time, setTime] = useState(0);
  const [inputVolumeBarWidth, setInputVolumeBarWidth] = useState(undefined);
  const [outputVolumeBarWidth, setOutputVolumeBarWidth] = useState(undefined);
  const [inputVolumeBarColor, setInputVolumeBarColor] = useState(undefined);
  const [outputVolumeBarColor, setOutputVolumeBarColor] = useState(undefined);

  useEffect(() => {
    const isCalling =
      status === VoiceStatus.calling || status === VoiceStatus.callAccepted;
    setIsOpen(isCalling || status === VoiceStatus.incomingCall);

    let interval = null;

    interval = setInterval(() => {
      if (isCalling) {
        setTime((time) => time + 10);
      } else {
        setTime(0);
      }
    }, 10);

    if (currentCall) {
      currentCall.on('volume', (inputVolume, outputVolume) => {
        let inputColor = 'red';
        if (inputVolume < 0.5) {
          inputColor = 'green';
        } else if (inputVolume < 0.75) {
          inputColor = 'yellow';
        }

        setInputVolumeBarWidth(`${Math.floor(inputVolume * 300)}px`);
        setInputVolumeBarColor(inputColor);

        let outputColor = 'red';
        if (outputVolume < 0.5) {
          outputColor = 'green';
        } else if (outputVolume < 0.75) {
          outputColor = 'yellow';
        }

        setOutputVolumeBarWidth(`${Math.floor(outputVolume * 300)}px`);
        setOutputVolumeBarColor(outputColor);
      });
    }
    return () => {
      clearInterval(interval);
    };
  }, [status, currentCall]);

  const getTitleText = () => {
    if (status === VoiceStatus.calling) {
      return 'Calling...';
    }
    if (status === VoiceStatus.callAccepted) {
      return 'Connected';
    }
    return '';
  };
  return (
    <Dialog open={isOpen}>
      {status === VoiceStatus.incomingCall && (
        <Grid
          container
          justifyContent="center"
          alignItems="center"
          direction="column"
          style={{ padding: 20 }}
        >
          <Grid item style={{ padding: 20 }}>
            <H3>Incoming call from : {currentCall.parameters.From}</H3>
          </Grid>
          <Grid item>
            <IconButton
              onClick={() => {
                acceptIncomingCall();
                setTime(0);
              }}
              color="primary"
              size="large"
              style={{ padding: 5 }}
            >
              <TelephonePlusFill color="green" size={33} />
            </IconButton>
            <IconButton
              onClick={() => {
                rejectIncomingCall();
                setTime(0);
              }}
              color="primary"
              size="large"
              style={{ padding: 5 }}
            >
              <TelephoneMinusFill color="red" size={33} />
            </IconButton>
          </Grid>
        </Grid>
      )}
      {status !== VoiceStatus.incomingCall && (
        <Grid
          container
          justifyContent="center"
          alignItems="center"
          direction="column"
          style={{ padding: 20 }}
        >
          <Grid item style={{ padding: 20 }}>
            <H3>{toNumber}</H3>
            <H3>{getTitleText()}</H3>
          </Grid>
          <Grid item>
            <Text>
              {`0${Math.floor((time / 60000) % 60)}`.slice(-2)}:
              {`0${Math.floor((time / 1000) % 60)}`.slice(-2)}
            </Text>
          </Grid>
          <Grid item style={{ padding: 20 }}>
            <Text>Mic Volume</Text>
            <Box
              style={{
                height: 20,
                backgroundColor: inputVolumeBarColor,
                width: inputVolumeBarWidth,
              }}
            />
            <Text>Speaker Volume</Text>
            <Box
              style={{
                height: 20,
                backgroundColor: outputVolumeBarColor,
                width: outputVolumeBarWidth,
              }}
            />
          </Grid>
          <Grid item>
            <IconButton
              onClick={() => {
                hangUp();
                setTime(0);
              }}
              color="primary"
              size="large"
              style={{ padding: 5 }}
            >
              <TelephoneMinusFill color="red" size={33} />
            </IconButton>
          </Grid>
        </Grid>
      )}
    </Dialog>
  );
};
